import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { REVIEWS_DEFAULT_VISIBLE } from '../../routes/Hotel/constants/reviews';
import type { ReviewStore } from './types';

export const initialState: ReviewStore = {
  fetching: false,
  visibleCount: 10,
  data: [],
};
const reviewSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    showMoreReviews: (state) => {
      const prevState = state.visibleCount;
      state.visibleCount = prevState + REVIEWS_DEFAULT_VISIBLE;
    },
    setReviewsData: (state, action: PayloadAction<ReviewStore['data']>) => {
      // @ts-ignore
      if (typeof state?.toJS === 'function') {
        return {
          // @ts-ignore
          ...state.toJS(),
          data: action.payload,
        };
      }
      return {
        ...state,
        data: action.payload,
      };
    },
  },
});

export const { showMoreReviews, setReviewsData } = reviewSlice.actions;
const { name, reducer } = reviewSlice;
export { reducer as default, name };
